<template>
  <div class="infoCaret" @mouseover="onMouseover" @mouseleave="onMouseleave">
    <img :src="image" style="height:100%"/>
    <div class="infoCaret__overlay"/>
    <div class="infoCaret__title" :class="{'infoCaret__title--hover': mouseHovered}">
      <p>{{ title }}</p>
    </div>
    <div v-if="message" class="infoCaret__message" :class="{'infoCaret__message--hover': mouseHovered}">
      <p v-if="mouseHovered">{{ message }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'InfoCaret',
    data(){
      return {
        mouseHovered: false
      }
    },
    props: {
      image: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      message: {
        type: String,
        required: false,
        default:""
      }
    },
    methods: {
      onMouseover() {
        this.mouseHovered = true;
      },
      onMouseleave() {
        this.mouseHovered = false;
      }
    }
  }
</script>

<style scoped>
.infoCaret {
  width: 210px;
  height: 360px;
  background-color:cornsilk;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.infoCaret__title {
  height: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
  transition: all .3s;
  text-transform: uppercase;
  font-size: 1.4rem;
  font-weight: bold;
  position: absolute;
  width: 100%;
  z-index: 2;
  color: #ffffff;
}
.infoCaret__message {
  height: 100%;
  transition: all .3s;
  position: absolute;
  z-index: 0;
  visibility: hidden;
  background-color: #ffffffad;
}
.infoCaret__message p{
 padding: 0 10px ;
 color: #2c3e50;
 font-size: 22px;
}
.infoCaret__title--hover {
  height: 50%;
  transition: all .3s;
}
.infoCaret__message--hover {
  height: 50%;
  width: 100%;
  visibility: visible;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  transition: all .3s;
  position: absolute;
  top: 50%;
  z-index: 1;
}
.infoCaret__overlay {
  height: 400px;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100%;
  display: block;
  position: absolute;
  top: 0px;
}
</style>